if (!window.__collectionLoadMoreInitialized) {
  window.__collectionLoadMoreInitialized = true;

  const setButtonLoadingState = (button, isLoading) => {
    const text = button.querySelector(".load-more__text");
    const spinner = button.querySelector(".load-more__spinner");

    button.disabled = isLoading;
    button.setAttribute("aria-busy", isLoading ? "true" : "false");

    if (text) text.classList.toggle("hidden", isLoading);
    if (spinner) spinner.classList.toggle("hidden", !isLoading);
  };

  document.addEventListener("click", async (event) => {
    const button = event.target.closest(".js-load-more-products");
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    const nextUrl = button.dataset.nextUrl;
    const sectionId = button.dataset.sectionId;
    const productGrid = document.getElementById("product-grid");

    if (!nextUrl || !sectionId || !productGrid) return;

    setButtonLoadingState(button, true);

    try {
      const response = await fetch(nextUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const html = await response.text();
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      const nextGrid = parsedHTML.getElementById("product-grid");

      if (!nextGrid) return;

      const nextItems = nextGrid.querySelectorAll(":scope > li");
      nextItems.forEach((item) => productGrid.appendChild(item));

      const currentLoadMore = document.getElementById(
        `CollectionLoadMore-${sectionId}`,
      );
      const nextLoadMore = parsedHTML.getElementById(
        `CollectionLoadMore-${sectionId}`,
      );

      if (currentLoadMore) {
        if (nextLoadMore) {
          currentLoadMore.replaceWith(nextLoadMore);
        } else {
          currentLoadMore.remove();
        }
      }

      if (typeof initializeScrollAnimationTrigger === "function") {
        initializeScrollAnimationTrigger(productGrid.innerHTML);
      }
    } catch (error) {
      console.error("Failed to load more products", error);
      setButtonLoadingState(button, false);
    }
  });
}
